export const VIDEO_URLS = {
    INTRO_VIDEO: 'https://player.vimeo.com/video/1089043996?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
}; 